import ActionTypes from '../constants';

const initialState = {
    allPolice: {},
    police: {}
    // loading: false,
};

const policeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPOLICESUCCESS:
            return {
                ...state,
                allPolice: action.payload,
            }
        case ActionTypes.GETPOLICEBYIDSUCCESS:
            return {
                ...state,
                police: action.payload,
            }
        default:
            return state;
    }
}

export default policeReducer;